//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: Editorial - Verify if possible to move into PDP (Lens panel)

export default {
  name: 'rb-tab-navigator',
  props: {
    className: {
      type: String,
      default: '',
    },
    contentList: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  data: function () {
    return {
      current: 0,
    }
  },
  methods: {
    startPrev(swiperIndex) {
      this.current = swiperIndex
      this.$emit('startPrev')
    },
    startNext(swiperIndex) {
      this.current = swiperIndex
      this.$emit('startNext')
    },
    init(swiper) {
      this.$emit('init', swiper)
    },
  },
}
